/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries {
    /**
    * Beginning of the search time frame for which statistics will be retrieved. Required when querying historical data. Format: ISO 8601 date string.
    */
    'startTime'?: Date;
    /**
    * End of the search time frame for which statistics will be retrieved. Required when querying historical data. Format: ISO 8601 date string.
    */
    'endTime'?: Date;
    /**
    * Specifies how to aggregate the data temporally. Choose TOTAL for aggregated results across the entire time period, or specify a granularity for time-series data. Options: HOUR, DAY, WEEK, MONTH, TOTAL. Default: TOTAL
    */
    'timeFrame'?: string;
    /**
    * Timezone the report is in
    */
    'timezone'?: string;
    /**
    * Filter results to specific campaigns by providing one or more campaign IDs
    */
    'campaignId'?: Array<string>;
    /**
    * Filter results to specific order lines by providing one or more order line IDs
    */
    'orderLineId'?: Array<string>;
    /**
    * Specifies how to break down the device statistics results by different entity levels. This provides separate result sets for each combination, allowing you to see performance metrics broken down by these dimensions. Available Options: org_id, campaign_id, order_line_id
    */
    'levelOfDetail'?: Array<string>;
    /**
    * Specify which metrics to include in the response. If not provided, all available metrics will be returned. Available Metrics: clicks (Total number of clicks across all impressions), completions (Number of video completions for video ads), conversions (Total number of post-view and post-click conversions), imps (Total number of impressions served), imps_viewed (Number of viewable impressions per IAB standards), pcts_25 (25% video completion rate), pcts_50 (50% video completion rate), pcts_75 (75% video completion rate), post_click_convs (Post-click conversions only), post_view_convs (Post-view conversions only), starts (Video start events), view_measured_imps (Impressions measured for viewability)
    */
    'metrics'?: Array<string>;
    /**
    * Unique identifier for the request
    */
    'requestId'?: string;
    /**
    * Enable analytics breakdown by bidder source. Optional parameter that defaults to false. (Not available to all roles)
    */
    'bidderSource'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "startTime",
            "baseName": "start_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "end_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "timeFrame",
            "baseName": "time_frame",
            "type": "string",
            "format": ""
        },
        {
            "name": "timezone",
            "baseName": "timezone",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "levelOfDetail",
            "baseName": "level_of_detail",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "bidderSource",
            "baseName": "bidder_source",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries.attributeTypeMap;
    }

    public constructor() {
    }
}

